import { createSelector } from 'reselect';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';

export const getOneCMSUrl = (state) => state.getIn(['config', 'oneCMSInternetSSRBaseUrl']);

export const getHomepageOneCmsUrl = createSelector(
  getOneCMSUrl,
  getActiveLocaleSelector,
  (oneCMSInternetSSRBaseUrl, activeLocale) => `${oneCMSInternetSSRBaseUrl}/Internet/travel/consumer-travel/${activeLocale?.toLowerCase()}/homepage.json`
);

export const getTravelFeatureFlagsOneCmsUrl = createSelector(
  getOneCMSUrl,
  (oneCMSInternetSSRBaseUrl) => `${oneCMSInternetSSRBaseUrl}/Internet/travel/featureFlags/featureFlags.json`
);
